import React, { Component } from 'react';
import { render, unmountComponentAtNode } from 'react-dom'
import PropTypes from 'prop-types'
import SweetAlert from 'react-bootstrap-sweetalert';

class SweetAlertWrapper extends Component {
    static propTypes = {
        title: PropTypes.string,
        description: PropTypes.string
    }

    static defaultProps = {
        title: "Are you sure?",
        description: "",
        type: {warning: true}
    }

    constructor(props) {
        super(props)

        this.state = {
            show: true
        }
    }

    render() {
        return (
            this.state.show ?
                <SweetAlert
                    title={this.props.title}
                    {...this.props.type}
                    showCancel
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => {
                        this.setState({ show: false }, () => {
                            removeElementReconfirm();
                            this.props.onConfirm();
                        });

                    }}
                    onCancel={() => {
                        this.setState({ show: false }, () => {
                            removeElementReconfirm();
                            this.props.onCancel();
                        });
                    }} >
                    {this.props.description}
        </SweetAlert> : null)
    }
}


function createElement(props) {
    let divTarget = document.getElementById('sweet-alert')

    if (divTarget) {
        // Rerender - the mounted ReactConfirmAlert
        render(<SweetAlertWrapper {...props} />, divTarget)
    } else {
        // Mount the ReactConfirmAlert component
        divTarget = document.createElement('div')
        divTarget.id = 'sweet-alert'
        document.body.appendChild(divTarget)
        render(<SweetAlertWrapper {...props} />, divTarget)
    }
}

function removeElementReconfirm() {
    const target = document.getElementById('sweet-alert')
    unmountComponentAtNode(target)
    target.parentNode.removeChild(target)
}



export function Confirm(props) {
    createElement(props);
}